var _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgManiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 46,
    fill: "none",
    viewBox: "0 0 48 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#863bff",
    d: "M25.946 44.938c-.664.845-2.021.375-2.021-.698V33.937a2.26 2.26 0 0 0-2.262-2.262H10.287c-.92 0-1.456-1.04-.92-1.788l7.48-10.471c1.07-1.497 0-3.578-1.842-3.578H1.237c-.92 0-1.456-1.04-.92-1.788L10.013.474c.214-.297.556-.474.92-.474h28.894c.92 0 1.456 1.04.92 1.788l-7.48 10.471c-1.07 1.498 0 3.579 1.842 3.579h11.377c.943 0 1.473 1.088.89 1.83L25.947 44.94z",
    style: {
      fill: "#863bff",
      fill: "color(display-p3 .5252 .23 1)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 48,
    height: 46,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M25.842 44.938c-.664.844-2.021.375-2.021-.698V33.937a2.26 2.26 0 0 0-2.262-2.262H10.183c-.92 0-1.456-1.04-.92-1.788l7.48-10.471c1.07-1.498 0-3.579-1.842-3.579H1.133c-.92 0-1.456-1.04-.92-1.787L9.91.473c.214-.297.556-.474.92-.474h28.894c.92 0 1.456 1.04.92 1.788l-7.48 10.471c-1.07 1.498 0 3.578 1.842 3.578h11.377c.943 0 1.473 1.088.89 1.832L25.843 44.94z",
    style: {
      fill: "#000",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.508,
    cy: 14.704,
    fill: "#ede6ff",
    rx: 5.508,
    ry: 14.704,
    style: {
      fill: "#ede6ff",
      fill: "color(display-p3 .9275 .9033 1)",
      fillOpacity: 1
    },
    transform: "matrix(.00324 1 1 -.00324 -4.47 31.516)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.399,
    cy: 29.851,
    fill: "#ede6ff",
    rx: 10.399,
    ry: 29.851,
    style: {
      fill: "#ede6ff",
      fill: "color(display-p3 .9275 .9033 1)",
      fillOpacity: 1
    },
    transform: "matrix(.00324 1 1 -.00324 -39.328 7.883)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.508,
    cy: 30.487,
    fill: "#7e14ff",
    rx: 5.508,
    ry: 30.487,
    style: {
      fill: "#7e14ff",
      fill: "color(display-p3 .4922 .0767 1)",
      fillOpacity: 1
    },
    transform: "rotate(89.814 -25.913 -14.639)scale(1 -1)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.508,
    cy: 30.599,
    fill: "#7e14ff",
    rx: 5.508,
    ry: 30.599,
    style: {
      fill: "#7e14ff",
      fill: "color(display-p3 .4922 .0767 1)",
      fillOpacity: 1
    },
    transform: "rotate(89.814 -32.644 -3.334)scale(1 -1)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.508,
    cy: 30.599,
    fill: "#7e14ff",
    rx: 5.508,
    ry: 30.599,
    style: {
      fill: "#7e14ff",
      fill: "color(display-p3 .4922 .0767 1)",
      fillOpacity: 1
    },
    transform: "matrix(.00324 1 1 -.00324 -34.34 30.47)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#g)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.072,
    cy: 22.078,
    fill: "#ede6ff",
    rx: 14.072,
    ry: 22.078,
    style: {
      fill: "#ede6ff",
      fill: "color(display-p3 .9275 .9033 1)",
      fillOpacity: 1
    },
    transform: "rotate(93.35 24.506 48.493)scale(-1 1)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.47,
    cy: 21.501,
    fill: "#7e14ff",
    rx: 3.47,
    ry: 21.501,
    style: {
      fill: "#7e14ff",
      fill: "color(display-p3 .4922 .0767 1)",
      fillOpacity: 1
    },
    transform: "rotate(89.009 28.708 47.59)scale(-1 1)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#i)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.47,
    cy: 21.501,
    fill: "#7e14ff",
    rx: 3.47,
    ry: 21.501,
    style: {
      fill: "#7e14ff",
      fill: "color(display-p3 .4922 .0767 1)",
      fillOpacity: 1
    },
    transform: "rotate(89.009 28.708 47.59)scale(-1 1)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#j)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.387,
    cy: 8.972,
    fill: "#7e14ff",
    rx: 4.407,
    ry: 29.108,
    style: {
      fill: "#7e14ff",
      fill: "color(display-p3 .4922 .0767 1)",
      fillOpacity: 1
    },
    transform: "rotate(39.51 .387 8.972)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#k)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.523,
    cy: -6.092,
    fill: "#7e14ff",
    rx: 4.407,
    ry: 29.108,
    style: {
      fill: "#7e14ff",
      fill: "color(display-p3 .4922 .0767 1)",
      fillOpacity: 1
    },
    transform: "rotate(37.892 47.523 -6.092)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#l)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.412,
    cy: 6.333,
    fill: "#47bfff",
    rx: 5.971,
    ry: 9.665,
    style: {
      fill: "#47bfff",
      fill: "color(display-p3 .2799 .748 1)",
      fillOpacity: 1
    },
    transform: "rotate(37.892 41.412 6.333)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#m)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -1.879,
    cy: 38.332,
    fill: "#7e14ff",
    rx: 4.407,
    ry: 29.108,
    style: {
      fill: "#7e14ff",
      fill: "color(display-p3 .4922 .0767 1)",
      fillOpacity: 1
    },
    transform: "rotate(37.892 -1.88 38.332)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#n)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -1.879,
    cy: 38.332,
    fill: "#7e14ff",
    rx: 4.407,
    ry: 29.108,
    style: {
      fill: "#7e14ff",
      fill: "color(display-p3 .4922 .0767 1)",
      fillOpacity: 1
    },
    transform: "rotate(37.892 -1.88 38.332)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#o)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.651,
    cy: 29.907,
    fill: "#7e14ff",
    rx: 4.407,
    ry: 29.108,
    style: {
      fill: "#7e14ff",
      fill: "color(display-p3 .4922 .0767 1)",
      fillOpacity: 1
    },
    transform: "rotate(37.892 35.651 29.907)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#p)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.418,
    cy: 32.4,
    fill: "#47bfff",
    rx: 5.971,
    ry: 15.297,
    style: {
      fill: "#47bfff",
      fill: "color(display-p3 .2799 .748 1)",
      fillOpacity: 1
    },
    transform: "rotate(37.892 38.418 32.4)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 60.045,
    height: 41.654,
    x: -19.77,
    y: 16.149,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2002_17158",
    stdDeviation: 7.659
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 90.34,
    height: 51.437,
    x: -54.613,
    y: -7.533,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2002_17158",
    stdDeviation: 7.659
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 79.355,
    height: 29.4,
    x: -49.64,
    y: 2.03,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2002_17158",
    stdDeviation: 4.596
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: 79.579,
    height: 29.4,
    x: -45.045,
    y: 20.029,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2002_17158",
    stdDeviation: 4.596
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: 79.579,
    height: 29.4,
    x: -43.513,
    y: 21.178,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2002_17158",
    stdDeviation: 4.596
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    width: 74.749,
    height: 58.852,
    x: 15.756,
    y: -17.901,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2002_17158",
    stdDeviation: 7.659
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    width: 61.377,
    height: 25.362,
    x: 23.548,
    y: 2.284,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2002_17158",
    stdDeviation: 4.596
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    width: 61.377,
    height: 25.362,
    x: 23.548,
    y: 2.284,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2002_17158",
    stdDeviation: 4.596
  })), /*#__PURE__*/React.createElement("filter", {
    id: "j",
    width: 56.045,
    height: 63.649,
    x: -27.636,
    y: -22.853,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2002_17158",
    stdDeviation: 4.596
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    width: 54.814,
    height: 64.646,
    x: 20.116,
    y: -38.415,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2002_17158",
    stdDeviation: 4.596
  })), /*#__PURE__*/React.createElement("filter", {
    id: "l",
    width: 33.541,
    height: 35.313,
    x: 24.641,
    y: -11.323,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2002_17158",
    stdDeviation: 4.596
  })), /*#__PURE__*/React.createElement("filter", {
    id: "m",
    width: 54.814,
    height: 64.646,
    x: -29.286,
    y: 6.009,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2002_17158",
    stdDeviation: 4.596
  })), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    width: 54.814,
    height: 64.646,
    x: -29.286,
    y: 6.009,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2002_17158",
    stdDeviation: 4.596
  })), /*#__PURE__*/React.createElement("filter", {
    id: "o",
    width: 54.814,
    height: 64.646,
    x: 8.244,
    y: -2.416,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2002_17158",
    stdDeviation: 4.596
  })), /*#__PURE__*/React.createElement("filter", {
    id: "p",
    width: 39.409,
    height: 43.623,
    x: 18.713,
    y: 10.588,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2002_17158",
    stdDeviation: 4.596
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManiLogo);
export default __webpack_public_path__ + "static/media/mani_logo.3f37a613861a356d17a6056551121733.svg";
export { ForwardRef as ReactComponent };